import { render } from "./NursingCenter.vue?vue&type=template&id=4e77b850&scoped=true"
import script from "./NursingCenter.vue?vue&type=script&lang=js"
export * from "./NursingCenter.vue?vue&type=script&lang=js"

import "./NursingCenter.vue?vue&type=style&index=0&id=4e77b850&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e77b850"]])

export default __exports__